import { render, staticRenderFns } from "./ChangePass.vue?vue&type=template&id=60d2a53f&scoped=true&"
import script from "./ChangePass.vue?vue&type=script&lang=js&"
export * from "./ChangePass.vue?vue&type=script&lang=js&"
import style0 from "./ChangePass.vue?vue&type=style&index=0&id=60d2a53f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d2a53f",
  null
  
)

export default component.exports